export default "__VITE_ASSET__DaheRfWm__"